/**
 * Iniciales y color de avatar (puro, sin React: lo usan frontend y tests).
 * Auditoría 18/09/2026: 4 implementaciones de
 * `getInitials` (una explotaba con espacios dobles: `name.split(' ')[i][0]`
 * de un string vacío) y la paleta `AVATAR_COLORS` copiada en dos archivos.
 * Tests: `npm run test:avatar`.
 */
export const AVATAR_COLORS = ['#C4B5FD', '#FDE68A', '#A5D8FF', '#FCA5A5', '#86EFAC', '#FBBF24'];

/**
 * Iniciales (máx. 2). Dos modos, con paridad exacta con lo que reemplazan:
 *  - `getInitials(name, lastName)`: primera letra de CADA campo ("Juan", "De La
 *    Fuente" ⇒ "JD"). Apellidos compuestos son la norma en LatAm/Brasil, por eso
 *    NO se parte el combinado en palabras.
 *  - `getInitials(fullName)`: primeras letras de las dos primeras palabras
 *    ("Juan Carlos Pérez" ⇒ "JC"); tolera espacios dobles.
 * `fallback` (por defecto '') si no hay nada.
 */
export function getInitials(name?: string | null, lastName?: string | null, fallback = ''): string {
  if (lastName != null) {
    const out = `${(name ?? '').trim().charAt(0)}${lastName.trim().charAt(0)}`.toUpperCase();
    return out || fallback;
  }
  const words = (name ?? '').split(/\s+/).filter(Boolean);
  return words.slice(0, 2).map((w) => w.charAt(0)).join('').toUpperCase() || fallback;
}

/** Color estable por nombre (hash simple sobre la paleta). */
export function getAvatarColor(name: string): string {
  let hash = 0;
  for (const c of name) hash = (hash * 31 + c.charCodeAt(0)) & 0xffffff;
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
